import React, { memo } from 'react'

import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import {
    threatConsequenceWidth,
    THREAT_COSNEQUENCE_GAP_X,
    threatConsequenceHeight
} from '../../../../../../../utils/constants'
import { AddButtonContainer, PopupSVG, StyledAddButton } from './styles'

type IProps = {
    type: 'threat' | 'consequence'
    x: number
    y: number
    onAddRequest: () => void
    customText?: string
    threatConsequenceLength: number
}

const AddThreatConsequence: React.FC<IProps> = ({ type, x, y, onAddRequest, customText, threatConsequenceLength }) => {
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    return (
        <AddButtonContainer
            transform={`translate(${(type === 'threat'
                ? x - threatConsequenceWidth - THREAT_COSNEQUENCE_GAP_X + 10
                : x + THREAT_COSNEQUENCE_GAP_X + 10) +
                (threatConsequenceLength === 0 ? 0 : threatConsequenceWidth / 4)}, ${y +
                threatConsequenceHeight / 2 +
                15})`}
            cursor="pointer"
            onClick={onAddRequest}
        >
            {threatConsequenceLength > 0 && (
                <PopupSVG transform={`translate(${type === 'threat' ? -105 : 65}, -4)`}>
                    <g transform={type === 'threat' ? 'translate(95, 4)' : 'translate(2, 4)'}>
                        <rect
                            className="svg-popup-helper"
                            height={16}
                            width={16}
                            transform="rotate(45)"
                            rx={2}
                            ry={2}
                        />
                    </g>
                    <foreignObject width={150} height={30} transform={type === 'threat' ? 'translate(-53 0)' : ''}>
                        <div className={type} style={type === 'threat' ? { marginLeft: 'auto' } : {}}>
                            {`${i18n('Add')} ${i18n(type)}`}
                        </div>
                    </foreignObject>
                </PopupSVG>
            )}
            {bowtieAdmin && (
                <StyledAddButton
                    x={type === 'threat' ? 10 : 25}
                    width={threatConsequenceLength > 0 ? 24 : 119}
                    height={24}
                    style={{ display: 'flex', alignItems: 'center' }}
                >
                    <div>
                        <i className="far fa-plus" />
                        {threatConsequenceLength > 0 ? '' : customText ?? i18n(type)}
                    </div>
                </StyledAddButton>
            )}
        </AddButtonContainer>
    )
}

export default memo(AddThreatConsequence)
